import axios from 'axios'

const WP_URL = `${process.env.WP_URL}wp-json/pixels-headless/v1/offerrequest`
const SECRET = process.env.HEADLESS_SECRET

/**
 * Send individual offer request to local API endpoint.
 */
export const sendOfferRequest = async (offerRequest) => {
  const result = await axios({
    method: 'post',
    url: '/api/offer-request',
    data: { offerRequest },
  })

  return result.data
}

export const sendOfferRequestToWP = async (data) => {
  const result = await axios({
    method: 'post',
    url: WP_URL,
    data: { ...data, secret: SECRET },
  })

  return result
}

export default {
  sendOfferRequest,
  sendOfferRequestToWP,
}
